class NicheArticle extends HTMLElement {
  connectedCallback() {
    this.progress = this.querySelector('[data-niche-progress]');
    this.links = [...this.querySelectorAll('[data-niche-chapter-link]')];
    this.chapters = this.links
      .map((link) => document.getElementById(link.getAttribute('href')?.slice(1)))
      .filter(Boolean);

    this.handleScroll = this.handleScroll.bind(this);
    this.updateFrame = null;
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleScroll, { passive: true });
    this.handleScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleScroll);
    if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
  }

  handleScroll() {
    if (this.updateFrame) return;
    this.updateFrame = requestAnimationFrame(() => {
      this.updateFrame = null;
      this.updateProgress();
      this.updateChapter();
    });
  }

  updateProgress() {
    if (!this.progress) return;
    const bounds = this.getBoundingClientRect();
    const scrollable = Math.max(1, bounds.height - window.innerHeight);
    const travelled = Math.min(scrollable, Math.max(0, -bounds.top));
    const progress = travelled / scrollable;
    this.progress.style.transform = `scaleX(${progress})`;
  }

  updateChapter() {
    if (!this.chapters.length) return;
    const active = [...this.chapters]
      .reverse()
      .find((chapter) => chapter.getBoundingClientRect().top <= 180) || this.chapters[0];

    this.links.forEach((link) => {
      const isActive = link.getAttribute('href') === `#${active.id}`;
      if (isActive) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  }
}

if (!customElements.get('niche-article')) {
  customElements.define('niche-article', NicheArticle);
}
